export default __webpack_public_path__ + "static/media/happy-fathers-day.4ea29b02.webp";